import { createSelector } from '@ngrx/store';

import find from 'lodash/find';
import { getCitation } from './get.citations';

export const getSelectedReferenceId = createSelector(
  getCitation,
  ({ references, selectedReferenceId }): string | null | undefined =>
    selectedReferenceId &&
    find(references, { citationId: selectedReferenceId }).referencedBy[0]
);
